var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-wrapper"},[_c('div',{staticClass:"used",style:(_vm.usedWidth)}),_c('div',{staticClass:"budget",style:(_vm.budgetWidth)}),_c('div',{staticClass:"overage",style:(_vm.overageWidth)})])
}
var staticRenderFns = []

export { render, staticRenderFns }